import tingle from 'tingle.js';

export default function (data) {
  const modals = document.querySelectorAll('.js-modal');
  const modalVideo = document.querySelectorAll('.js-card-video-thumb');

  if (!modals) {
    return;
  }

  // When 'read more' button is clicked, open modal
  [].forEach.call(modals, (function (element) {
    if (!hasClass(element, 'js-modal-bound')) {
      addClass(element, 'js-modal-bound');
      element.addEventListener('click', function (e) {
        e.preventDefault();

        initModal(element, data, false);
      });
    }
  }));

  // When youtube thumbnail is clicked, open modal
  if (modalVideo) {
    [].forEach.call(modalVideo, (function (videoElement) {
      videoElement.addEventListener('click', function (e) {
        e.preventDefault();

        initModal(videoElement.nextElementSibling, data, true);
      });
    }));
  }
};

/**
 * Add event to close btn in the modal
 *
 * @param closeBtn
 * @param modal
 * @private
 */
function addEventCloseBtn(closeBtn, modal) {
  if (!closeBtn) {
    return;
  }

  closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    modal.close();
    e.preventDefault();
  });
}

function initModal(element, data, autoplay) {
  const modal = new tingle.modal({
    closeMethods: ['overlay'],
    cssClass: ['modal'],
    onClose: function () {
      modal.destroy();
    }
  });

  const index = element.getAttribute('data-index');
  let template;

  template = `<div class="card__header">
            <img class="card__header__image" src="${data[index].meta.avatar}">
            <div class="card__header__content">
              <span class="card__header__title">
                ${data[index].meta.author}
              </span>
              <span class="card__header__subtitle">
                ${data[index].meta.type}
              </span>
              <span class="card__header__date">
                ${data[index].date}
              </span>
            </div>
            <div class="card__close js-modal-close"></div>
          </div>`;

  if (data[index].image != null) {
    template += `<div class="card__body__image-wrapper card__body__image-wrapper--modal"><img class="card__body__image" src="${data[index].image}"></div>`;
  }

  template += `<div class="card__body">
            <h5 class="card__body__title">
              ${data[index].title}
            </h5>
            <p class="card__body__text">
              ${data[index].content}
            </p>
          </div>`;

  if (data[index].youtube != null) {
    template += `<div class="card__body__video"><iframe src="https://www.youtube.com/embed/${data[index].youtube}` + (autoplay ? '?autoplay=1' : '') + `" frameborder="0" allowfullscreen></iframe></div>`;
  }
  if (data[index].button != null) {
    template += `<a class="card__button" href="${data[index].button.link}">${data[index].button.label}</a>`;
  }

  modal.setContent(template);
  modal.open();

  addEventCloseBtn(document.querySelector('.js-modal-close'), modal);
}
